// extracted by mini-css-extract-plugin
export default {"dialog":"tKvlN","header":"X2hhY","title":"ZBHIY","tab":"J7ERb"};